module.exports = __webpack_public_path__ + "img/giftcard-illustration.6a1f81a0.svg";